<template>
  <div class="transaction-panel">
    <div class="layout-left d-flex align-items-start flex-column">
      <div class="detail-info mb-auto">
        <p class="data-info">ข้อมูลลูกค้า</p>
        <p class="title-info">หมายเลขสมาชิก (Member No.)</p>
        <p class="data-info">{{ transactions.memberId }}</p>
        <p class="title-info">ชื่อลูกค้า (Customer Name)</p>
        <p class="data-info">
          {{ transactions.firstNameTh }} {{ transactions.lastNameTh }}
        </p>
        <p class="title-info">โทรศัพท์ (Telephone)</p>
        <p class="data-info">{{ transactions.telephone }}</p>

        <div class="text-center action-desktop">
          <b-button
            variant="primary-color"
            class="w-75"
            :disabled="transactions.depositStatus != 1"
            @click="showReturnDepositModal"
          >
            ออกใบลดหนี้/คืนเงิน
          </b-button>
        </div>
      </div>
      <div class="text-center w-100 pb-3 action-desktop">
        <b-button variant="primary-color" to="/deposit"> ย้อนกลับ </b-button>
      </div>
    </div>
    <div class="layout-right p-3">
      <div class="transaction-status">
        <div>
          <p class="text-ref-no">
            DEP REF NO: {{ transactions.invoiceNo }}
            <b-button
              class="ml-2"
              variant="outline-primary-color"
              @click="printPDF"
            >
              <font-awesome-icon icon="print" class="pointer color-primary" />
              ปริ้นใบมัดจำ
            </b-button>
          </p>
          <p class="text-time d-flex">
            {{
              $moment(transactions.createdTime)
                .add(543, "years")
                .format($formatDateNewFull)
            }}
            สาขา {{ transactions.branchName }}
            <span class="text-warning ml-2"
              ><li>{{ transactions.depositTypeName }}</li></span
            >
          </p>
          <div>
            รับชำระแล้ว : {{ transactions.deposit_price | numeral("0,0.00") }}
          </div>
        </div>
        <div class="detail">
          <p
            :class="[
              'text-status',
              transactions.depositStatus == 1 ? 'text-warning' : 'text-danger',
            ]"
          >
            สถานะการขาย: {{ transactions.depositStatusName }}
          </p>
          <p class="text-saleId">
            <b>#{{ transactions.salesNo }} {{ transactions.salesName }}</b>
          </p>
          <p>
            <b>
              วันนัดรับ :
              {{
                $moment(transactions.pickupDate).format("DD/MM/YYYY (HH:mm:ss)")
              }}</b
            >
          </p>
        </div>
      </div>

      <template v-if="!isMobile">
        <div class="m-3">
          <b-row class="mx-0 text-center header-products">
            <b-col cols="1" class="header-products-item">
              <p>จำนวน</p>
              <p>Qty</p>
            </b-col>
            <b-col md="5" class="header-products-item text-left">
              <p>รายละเอียดสินค้า/โปรโมชั่น</p>
              <p>Description/Promotion</p>
            </b-col>

            <b-col class="header-products-item">
              <p>ราคาต่อหน่วย</p>
              <p>Unit Price</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ส่วนลด</p>
              <p>Discount</p>
            </b-col>
          </b-row>
        </div>
        <div class="product-list-container">
          <div class="item-products" v-if="transactions.products.length > 0">
            <b-row
              v-for="(product, index) in transactions.products"
              :key="index"
              class="product-panel mx-0 mb-2 h-100 py-2"
            >
              <b-col
                cols="1"
                class="border-product d-flex justify-content-center align-items-center"
              >
                <p class="my-0">{{ product.quantity }}</p>
              </b-col>
              <b-col md="5" class="pointer">
                <div class="d-flex align-items-center">
                  <b-img
                    :src="product.image_url || default_image"
                    alt="product image"
                    class="product-image"
                    @error="handleImageSrc"
                  />

                  <div>
                    <p>{{ product.barcode }}</p>
                    <p
                      v-if="product.product_group_barcode_detail"
                      class="product-info"
                    >
                      Group Barcode: {{ product.product_group_barcode_detail }}
                      {{ product.gp_rate }}%
                    </p>
                    <p class="product-info">
                      {{ product.name }}

                      <span v-if="product.serial">
                        (Serial: {{ product.serial }})
                      </span>
                    </p>
                    <p
                      class="product-info"
                      v-if="product.article_type == 'ZGOLD'"
                    >
                      น้ำหนัก :
                      <span>{{ product.weight | numeral("0,0.00") }} </span>
                    </p>
                    <p v-if="product.promotion">
                      <span>
                        โปรโมชั่น:
                        {{
                          !product.promotion || product.promotion.length == 0
                            ? "-"
                            : ""
                        }}</span
                      >
                      <span
                        v-for="(promotion, index2) in product.promotion"
                        :key="index2"
                      >
                        {{ promotion.name }} ลด {{ promotion.discount_value }}
                        <template v-if="index2 != product.promotion.length - 1">
                          ,
                        </template>
                      </span>
                    </p>
                  </div>
                </div>
              </b-col>

              <b-col
                class="price d-flex justify-content-center align-items-center"
              >
                <div>
                  <p>
                    {{ product.sap_price | numeral("0,0.00") }}
                  </p>
                  <p
                    v-if="product.sap_price != product.price"
                    class="normal-unit-price"
                  >
                    {{ product.price | numeral("0,0.00") }}
                  </p>
                  <p>(ราคา ณ วันที่จอง)</p>
                </div>
              </b-col>

              <b-col
                class="price d-flex justify-content-center align-items-center"
              >
                <p>
                  {{
                    (product.sap_price * product.quantity -
                      product.after_discount_price)
                      | numeral("0,0.00")
                  }}
                </p>
                <div
                  v-if="product.article_type == 'ZGOLD'"
                  class="d-flex justify-content-center mt-2"
                >
                  <div class="">
                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                      >
                        มูลค่าทอง
                        <font-awesome-icon
                          :id="`tooltip-gold-variable-${index}`"
                          icon="exclamation-circle"
                          class="pointer icon-exclamation"
                        />
                        <b-tooltip
                          :target="`tooltip-gold-variable-${index}`"
                          placement="left"
                        >
                          ราคาทองประจำวัน ต่อกรัม
                          {{ product.gold_price_per_gram | numeral("0,0.00") }}
                          *
                          {{ product.weight | numeral("0,0.00") }}
                        </b-tooltip>
                      </b-col>

                      <b-col class="text-left">
                        {{
                          (product.after_discount_price - product.cost_vat)
                            | numeral("0,0.00")
                        }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                      >
                        ค่าแรงรวม VAT
                        <font-awesome-icon
                          :id="`vat-tooltip-${index}`"
                          icon="exclamation-circle"
                          class="pointer icon-exclamation"
                        />
                        <b-tooltip
                          :target="`vat-tooltip-${index}`"
                          placement="left"
                        >
                          ค่าแรงรวม = ราคาขายสินค้า - มูลค่าทอง
                        </b-tooltip>
                      </b-col>

                      <b-col class="text-left">
                        {{ product.cost_vat | numeral("0,0.00") }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                      >
                        ค่าแรงไม่รวม
                      </b-col>

                      <b-col class="text-left">
                        {{ product.cost | numeral("0,0.00") }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >VAT
                      </b-col>

                      <b-col class="text-left">
                        {{ product.vat | numeral("0,0.00") }}
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="transactions.products.length > 0">
          <b-row
            class="mx-0 my-1 p-2 bg-white product-panel"
            v-for="(product, index) in transactions.products"
            :key="index"
          >
            <b-col
              cols="2"
              class="text-center pl-0 pr-0 border-product d-flex align-items-center"
            >
              <p>{{ product.quantity }}</p>
            </b-col>

            <b-col class="px-2 pointer text-general text-nowrap">
              <div class="d-flex align-items-center">
                <b-img
                  :src="product.image_url || default_image"
                  alt="product image"
                  class="product-image"
                  @error="handleImageSrc"
                />

                <div>
                  <p>{{ product.barcode }}</p>
                  <p
                    v-if="product.product_group_barcode_detail"
                    class="product-info"
                  >
                    Group Barcode: {{ product.product_group_barcode_detail }}
                    {{ product.gp_rate }}%
                  </p>
                  <p>
                    {{ product.name }}
                    <span v-if="product.serial">
                      (Serial: {{ product.serial }})
                    </span>
                  </p>

                  <p>
                    โปรโมชั่น:
                    {{ product.promotionDetail || "-" }}
                  </p>
                </div>
              </div>
            </b-col>

            <b-col class="pr-0 pointer text-right">
              <div>
                <p>
                  {{ product.sap_price | numeral("0,0.00") }}
                </p>
                <p
                  v-if="product.sap_price != product.price"
                  class="normal-unit-price"
                >
                  {{ product.price | numeral("0,0.00") }}
                </p>
              </div>
            </b-col>
            <b-col cols="3" xl="2" class="price">
              <p v-if="product" class="fs-16">
                {{ product.net_price | numeral("0,0.00") }}
              </p>
            </b-col>
          </b-row>
        </div>
      </template>

      <hr class="" />

      <div
        class="text-center d-flex justify-content-center align-items-center p-3"
      >
        <b-button
          variant="primary-color"
          active
          :disabled="totalPage < 2 || filter.page <= 1"
          @click="changePage('prev')"
        >
          Prev
        </b-button>
        <p class="px-2">{{ filter.page }} / {{ totalPage }}</p>
        <b-button
          variant="primary-color"
          :disabled="totalPage < 2 || filter.page === totalPage"
          @click="changePage('next')"
        >
          Next
        </b-button>
      </div>

      <TransactionDetail
        :transactions="transactions.cnInvoice"
        :isMobile="isMobile"
      />
    </div>

    <div class="action-mobile">
      <b-button
        variant="primary-color"
        class="w-50"
        :disabled="transactions.depositStatus != 1"
        @click="showReturnDepositModal"
      >
        ออกใบลดหนี้/คืนเงิน
      </b-button>

      <b-button variant="primary-color" to="/deposit"> ย้อนกลับ </b-button>
    </div>
    <b-modal
      v-model="returnDepositModal"
      ref="modal"
      centered
      size="md"
      hide-footer
      title="ออกใบลดหนี้/คืนเงิน"
      footer-class="pt-0 border-0"
    >
      <b-row class="p-3 row-gap-lg justify-content-center">
        <b-col cols="12" class="text-center">
          <b-button class="w-50" @click="cancelTransaction(1)">เครดิต</b-button>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button class="w-50" @click="cancelTransaction(0)"
            >คืนเงิน</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import InputSelect from "@/components/inputs/InputSelect";
import TransactionDetail from "./components/transactionDetail";

export default {
  components: {
    InputSelect,
    TransactionDetail,
  },
  computed: {
    invoiceNo() {
      let filtered = this.transactionList.filter(
        (item) => this.form.transactionId == item.id
      );
      filtered = filtered.map((item, index) => item.invoiceNo);
      return filtered[0] || "";
    },
    selectedTransaction() {
      let filtered = this.transactions.find(
        (item) => this.form.transactionId == item.id
      );

      return filtered;
    },
    ...mapGetters(["isLoading"]),
    ...mapGetters({
      mainLoading: "getMainLoading",
      branchId: "getBranchId",
      pointSystem: "getPointSystem",
      isFullPos: "getIsFullPos",
      permission: "getRolePermission",
    }),
  },
  data() {
    return {
      isMobile: false,
      user: {
        center_point: 0,
        created_time: "",
        credit: 0,
        first_name_th: "",
        last_name_th: "",
        member_id: "",
        member_level_id: 0,
        member_level_name: "",
        point: 0,
        telephone: "",
        user_guid: "",
        user_id: 0,
        valid_user: 1,
        birthday: "",
        consent_status: "",
        sumPoint: 0,
      },
      params: {
        userGuid: "",
        transactionId: "",
        showOther: 0,
      },
      form: {
        transactionId: 0,
        is_store_credit: false,
      },
      transactionList: [],
      transactions: [],
      filter: {
        page: 1,
      },
      totalPage: 1,
      returnDepositModal: false,
    };
  },
  async created() {
    // if (!this.permission.includes(3)) return this.$router.push("/");
    await this.$store.dispatch("setMainLoading", true);
    // this.params.userGuid = this.$route.params.userGuid || "";
    // this.params.transactionId = this.$route.params.id;
    // this.form.transactionId = this.params.transactionId;
    // this.params.showOther = this.$route.params.showOther == 1 ? 0 : 1;
    // if (!this.params.transactionId)
    //   this.$router.push({ path: `/transaction` }).catch(() => {});
    // await this.getUserDetail(this.params.userGuid);
    // await this.getInvoiceList(
    //   this.params.userGuid,
    //   this.$route.params.showOther
    // );
    await this.getTransactionDetail(this.form.transactionId);
    await this.$store.dispatch("setMainLoading", false);
  },
  mounted() {
    this.onResize();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    async afterCancel() {
      await this.getInvoiceList(
        this.params.userGuid,
        this.$route.params.showOther
      );
      this.form.transactionId = 0;
      await this.getTransactionDetail(this.form.transactionId);
    },
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },

    async getUserDetail(userGuid) {
      await this.axios
        .get(
          `${this.$baseUrl}/customer/user_lookup_byid/${userGuid}/${this.branchId}`
        )
        .then(async (data) => {
          if (data.result == 1) {
            this.user = data.detail;
            if (this.user.birthday == "01/01/0001 00:00:00")
              this.user.birthday = null;
            else
              this.user.birthday = this.$moment(
                this.user.birthday,
                "MM/DD/YYYY HH:mm:ss"
              ).format("YYYY-MM-DD HH:mm:ss");
            this.user.sumPoint = data.detail.center_point + data.detail.point;
          }
        });
    },
    async getTransactionDetail(transactionId) {
      await this.axios
        .get(`${this.$baseUrl}/deposit/${this.$route.params.id}`)
        .then(async (data) => {
          if (data.result == 1) {
            // this.totalPage = data.total_page;
            this.transactions = data.detail;
            // this.form.is_store_credit = this.transactions[0].is_store_credit;
            // this.form.is_top_up_credit = this.transactions[0].is_top_up_credit;
            // await this.transactions.forEach((transaction) => {
            //   transaction.quantity = transaction.product.reduce(
            //     (a, b) => a + (b.quantity || 0),
            //     0
            //   );
            //   transaction.price =
            //     transaction.discount + transaction.grand_total;
            //   transaction.product.forEach((product) => {
            //     product.promotionDetail = product.promotion
            //       .map((el) => el.name)
            //       .join(", ");
            //   });
            // });
          } else {
            this.warningAlert(data.message);
          }
        });
    },
    async getInvoiceList(userGuid, showOther = 0) {
      let list = [{ id: 0, invoiceNo: "ทั้งหมด" }];
      await this.axios
        .get(
          `${this.$baseUrl}/transaction/get_invoice_list/${userGuid}/${showOther}/${this.branchId}`
        )
        .then(async (data) => {
          if (data.result == 1) {
            this.transactionList = list.concat(data.detail);
          }
        });
    },
    async onDataChangeTransaction(val) {
      this.form.transactionId = val;
      this.getTransactionDetail(this.form.transactionId);
    },

    async changePage(type) {
      if (type == "prev") this.filter.page -= 1;
      else if (type == "next") this.filter.page += 1;

      await this.getTransactionDetail(0);
    },
    async exportTransaction(transaction) {
      await this.axios
        .get(`${this.$baseUrl}/Export/export_customer_point/${transaction.id}`)
        .then(async (data) => {
          var link = document.createElement("a");
          document.body.appendChild(link);
          link.setAttribute("type", "hidden");
          link.href = "data:application/pdf;base64," + data.detail;
          link.setAttribute(
            "download",
            `transaction-${transaction.invoiceNo}.pdf`
          );
          link.setAttribute("target", `_blank`);
          link.click();
        });
    },
    async printFile(transaction) {
      await this.axios
        .get(
          `${this.$baseUrl}/transaction/GetTransactionReceipt/${transaction.id}`
        )
        .then(async (data) => {
          this.printReceipt(data);
        });
    },
    async printReceipt(Base64String) {
      await this.axios
        .post("http://localhost:30033/api/PrintReceipt", { Base64String })
        .then(async (data) => {
          if (data.result !== 1) {
            this.warningAlert(data.message);
          }
        })
        .catch((err) => {});
    },
    selectBilling(id) {
      this.$refs.modalBilling.show(id);
    },
    async setUserSelect({ user_guid, first_name_th, last_name_th, member_id }) {
      try {
        this.confirmAlert(
          `คุณต้องการโอนบิลไปยัง ${first_name_th} ${
            last_name_th || ""
          } (${member_id}) หรือไม่ ?`,
          "ยืนยัน"
        ).then(async (val) => {
          if (val.isConfirmed) {
            await this.$store.dispatch("setMainLoading", true);
            let payload = {
              transaction_id: this.$route.params.id,
              user_guid: user_guid,
            };
            await this.axios
              .post(`${this.$baseUrl}/transaction/TransferTransaction`, payload)
              .then(async (data) => {
                await this.$store.dispatch("setMainLoading", false);
                if (data.result == 1) {
                  this.successAlert().then(() => {
                    this.$router.replace(
                      `/transaction/detail/${this.$route.params.id}/${user_guid}/0`
                    );
                  });
                } else this.errorAlert(data.message);
                // this.printReceipt(data);
              });
          }
        });
      } catch (error) {
        this.erroAlert(error.message);
        await this.$store.dispatch("setMainLoading", false);
      }
    },
    getNewList() {
      this.$refs.modalBillingList.getData();
    },
    async printPDF() {
      try {
        await this.$store.dispatch("setMainLoading", true);
        const response = await this.axios.get(
          `${this.$baseUrl}/deposit/pdf/${this.$route.params.id}`,
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([response], { type: "application/pdf" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `deposit-${this.transactions.invoiceNo}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        await this.$store.dispatch("setMainLoading", false);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        await this.$store.dispatch("setMainLoading", false);
        console.error("Error downloading PDF:", error);
      }
      // this.$refs.modalBillingList.show();
    },
    showReturnDepositModal() {
      this.returnDepositModal = true;
    },
    async cancelTransaction(id) {
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.axios.post(`${this.$baseUrl}/deposit/void`, {
        transactionId: this.$route.params.id,
        is_credit: id,
        t_datetime: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
      });
      if (res.result == 1) {
        this.returnDepositModal = false;
        await this.$store.dispatch("setMainLoading", false);
        await this.successAlert(),
          await this.getTransactionDetail(this.form.transactionId);
      } else {
        await this.$store.dispatch("setMainLoading", false);
        this.errorAlert();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .layout-left {
  width: 300px;
  background: #f7f7f7;
  height: calc(100vh - 46px);
  position: relative;
  font-family: Kanit-Medium !important;

  .detail-info {
    padding: 20px;
    width: 100%;
    .title-info {
      font-size: 14px;
      color: grey;
    }

    .data-info {
      color: #333;
      font-size: 16px;
      text-align: left;
      margin-bottom: 15px;
    }
  }
}

::v-deep .layout-right {
  width: calc(100% - 300px);
  height: calc(100vh - 46px);
  overflow: auto;

  .transaction-status {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;

    .detail {
      text-align: right;
    }
  }

  .text-ref-no {
    font-family: Kanit-Medium !important;
    font-size: 20px;
  }

  .text-time,
  .text-saleId {
    font-family: Kanit-Medium !important;
    font-size: 14px;
  }

  .text-status {
    font-family: Kanit-Medium !important;
    font-size: 18px;
  }

  .text-status.text-success {
    color: #3c763d !important;
  }

  .head-total {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    p {
      text-align: center;
      color: var(--primary-color) !important;
      font-size: 14px;
      font-weight: 600;
    }

    .col:first-of-type {
      padding-left: 0;
    }

    .col {
      flex: 1;
    }

    .bg-secondary {
      height: 100%;
      padding: 15px 0;
      background: var(--secondary-color) !important;
    }

    .points {
      font-size: 14px;
    }
  }

  .product-list-container {
    overflow: auto;
    // height: calc(100% - 46px - 89px - 87px - 40px);
    position: relative;

    .wrap-no-product {
      width: 100%;
      height: 100%;
      display: -ms-flexbox !important;
      display: flex !important;
      -ms-flex-pack: center !important;
      justify-content: center !important;
      -ms-flex-align: center !important;
      align-items: center !important;

      .no-product {
        text-align: center;
        font-size: 20px;
        padding: 15px;
        background-color: #f7f7f7;
        border-radius: 5px;
        color: #dcdcdc;
        width: 450px;
      }
    }
  }

  .header-products {
    font-size: 14px;
    font-weight: bold;
    gap: 4px;

    .header-products-item {
      padding: 0px;
    }
  }

  .product-panel {
    background-color: rgb(244, 244, 244) !important;
  }

  .product-panel.active {
    background-color: var(--secondary-color) !important;
  }

  .item-products {
    color: #707070;
    font-size: 16px;
    border-radius: 8px;
    font-family: Kanit-Medium !important;

    svg {
      color: #000;
    }

    .price {
      font-size: 14px;
      text-align: center;
    }

    .product-info {
      font-size: 12px !important;
    }

    span {
      font-size: 12px;
      color: #707070 !important;
    }

    .normal-unit-price {
      text-decoration: line-through;
    }
  }
}

::v-deep .btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  text-decoration: underline !important;
  padding: 5px 0;
  color: #707070 !important;
}

.transaction-panel {
  display: flex;
}

.action-desktop {
  display: block;
}

.action-mobile {
  display: none;
}

@media (max-width: 1200px) {
  ::v-deep .layout-right {
    .head-total {
      p {
        font-size: 12px;
      }
    }
  }
}

@media (max-width: 768px) {
  .transaction-panel {
    display: block;

    .layout-left {
      width: 100%;
      height: 100%;

      .detail-info {
        width: 100%;
      }
    }

    .layout-right {
      width: 100%;
      height: 100%;

      .transaction-status {
        display: block;

        .detail {
          text-align: left;
        }
      }
    }

    .action-desktop {
      display: none;
    }

    .action-mobile {
      display: flex;
      flex-direction: column;
      gap: 16px;
      align-items: center;
      margin-bottom: 16px;
      width: 100%;
    }
  }
}

.f-14 {
  font-size: 14px !important;
}
.row-gap-lg {
  row-gap: 15px;
}
</style>
